import React from 'react';
import { motion } from 'framer-motion';

export const Card = ({ children, className = '', delay = 0, hover = true }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay }}
      className={`bg-slate-900/50 border border-slate-800 rounded-xl p-6 backdrop-blur-sm 
        ${hover ? 'hover:border-indigo-500/50 transition-colors duration-300' : ''} ${className}`}
    >
      {children}
    </motion.div>
  );
};